module.exports = __webpack_public_path__ + "static/media/banner_4.5eccd3a1.png";